import InfiniteScroll from 'infinite-scroll';

import componentRenderService from '../services/component-render.service';
import AudioListItemPlayer from '../react/renders/audio-list-item-player';
import AudioComments from '../react/renders/audio-comments';

const pageFeedEl = document.querySelector('.page-feed .audio-feed-items');

if (pageFeedEl) {
  new InfiniteScroll(pageFeedEl, {
    path: '.pagination .page-link-next',
    append: '.audio-feed-items > .feed-list-item',
    history: false,
  });
  /* Activate .audio-list-item-player on added elements: */
  new MutationObserver((mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((audioListItemEl) => {
          const audioCommentsEl = audioListItemEl.querySelector('.audio-comments');
          if (audioCommentsEl) {
            componentRenderService.byElement(audioCommentsEl, AudioComments);
          }
          const audioListItemPlayerEl = audioListItemEl.querySelector('.audio-list-item-player');
          if (audioListItemPlayerEl) {
            componentRenderService.byElement(audioListItemPlayerEl, AudioListItemPlayer);
          }
        });
      }
    }
    /* Set events on new videos */
    window.dashboardSetPlayCountIncrementEventForVideos();
  }).observe(pageFeedEl, {
    childList: true,
  });
}
